import { useEffect } from "react";
import { observer } from "mobx-react";
import { useTranslation } from "react-i18next";
import { useXlsImporterSettings } from "@tools";
import { Checkbox } from "@components";
import Grid from "@material-ui/core/Grid";

export const Sheets = observer(() => {
  const { t } = useTranslation();
  const settings = useXlsImporterSettings();

  const { xlsData, activeSheet } = settings;

  useEffect(() => {
    if (xlsData && activeSheet < 0) {
      settings.updateActiveSheet(0);
      if (xlsData.length === 1) settings.unlockStep(2);
    }
  }, [xlsData]);

  return (
    <Grid
      item
      container
      wrap="nowrap"
      direction="column"
    >
      <p className="text-lg font-bold">
        {t("views.import.sheets_title")}
        {":"}
      </p>
      <Grid
        item
        container
        direction="column"
        justifyContent="flex-end"
        className="mt-2 px-2"
      >
        {xlsData.map((s, i) => (
          <Checkbox
            key={s.title + i}
            name={s.title}
            checked={activeSheet === i}
            onChange={() => settings.updateActiveSheet(i)}
            disabled={xlsData.length === 1}
            label={s.title}
            labelClassName="my-1"
          />
        ))}
      </Grid>
    </Grid>
  );
});
